export type CameraSetup = (typeof CameraSetup)[keyof typeof CameraSetup];

export const CameraSetup = {
  mobile: 'mobile',
  static: 'static',
} as const;
